import type { JobEmailDto } from "@/lib/job-emails";

export interface JobEmailThreadProps {
  jobId: number;
  emails: JobEmailDto[];
  onSend: (body: { toEmailAddress: string; subject: string; htmlBody: string }) => void;
}

export function JobEmailThread({ emails, onSend }: JobEmailThreadProps) {
  function handleSend() {
    // Stub: in a real implementation this would open a compose dialog.
    onSend({ toEmailAddress: "", subject: "", htmlBody: "" });
  }

  return (
    <div className="space-y-3" data-testid="job-email-thread">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium">Email Thread</h3>
        <button
          type="button"
          className="rounded bg-primary px-3 py-1 text-xs font-medium text-primary-foreground hover:opacity-90"
          onClick={handleSend}
        >
          Send email
        </button>
      </div>

      {emails.length === 0 ? (
        <p className="text-sm text-muted-foreground">No emails</p>
      ) : (
        <ul className="space-y-2">
          {emails.map((email) => (
            <li
              key={email.jobEmailId}
              className="rounded border border-border p-3 space-y-1"
              data-testid="email-item"
            >
              <p className="text-sm font-medium">{email.subject}</p>
              <div className="flex gap-4 text-xs text-muted-foreground">
                <span>To: {email.toEmailAddress}</span>
                <span>{new Date(email.sentAtUtc).toLocaleString()}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
